var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrongHomeSection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2871 7.125C15.2871 7.58203 14.9062 7.9375 14.4746 7.9375H13.6621L13.6875 12C13.6875 12.0762 13.6875 12.1523 13.6875 12.2031V12.6094C13.6875 13.1934 13.2305 13.625 12.6719 13.625H12.2656C12.2148 13.625 12.1895 13.625 12.1641 13.625C12.1387 13.625 12.0879 13.625 12.0625 13.625H11.25H10.6406C10.0566 13.625 9.625 13.1934 9.625 12.6094V12V10.375C9.625 9.94336 9.24414 9.5625 8.8125 9.5625H7.1875C6.73047 9.5625 6.375 9.94336 6.375 10.375V12V12.6094C6.375 13.1934 5.91797 13.625 5.35938 13.625H4.75H3.9375C3.88672 13.625 3.86133 13.625 3.81055 13.625C3.78516 13.625 3.75977 13.625 3.73438 13.625H3.32812C2.74414 13.625 2.3125 13.1934 2.3125 12.6094V9.76562C2.3125 9.76562 2.3125 9.74023 2.3125 9.71484V7.9375H1.5C1.04297 7.9375 0.6875 7.58203 0.6875 7.125C0.6875 6.89648 0.763672 6.69336 0.941406 6.51562L7.44141 0.828125C7.61914 0.650391 7.82227 0.625 8 0.625C8.17773 0.625 8.38086 0.675781 8.5332 0.802734L15.0078 6.51562C15.2109 6.69336 15.3125 6.89648 15.2871 7.125Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrongHomeSection);
export default ForwardRef;